module.exports = __webpack_public_path__ + "img/img-widget-question.3e52d5e0.svg";